import './hooks';
import Vue from 'vue';
import VueRouter from 'vue-router';
import AccountStatusSettings from '@/views/AccountStatusSettings.vue';
import TransactionClassification from '@/views/TransactionClassification.vue';
import LegacyRedirect from '@/views/LegacyRedirect.vue';
import IncomingRedirect from '@/views/IncomingRedirect.vue';
import CoreManagement from '@/views/CoreManagement.vue';
import RelationshipClassification from '@/views/RelationshipClassification.vue';
import AccountTypes from '@/views/AccountTypes.vue';
import StatementCodes from '@/views/StatementCodes.vue';
import ProcessingDaysAndHolidays from '@/views/ProcessingDaysAndHolidays.vue';
import InterestSettings from '@/views/InterestSettings.vue';
import ATMSettings from '@/views/ATMSettings.vue';
import AuditMessages from '@/views/AuditMessages.vue';
import EocEmailSettings from '@/views/EocEmailSettings.vue';
import CycleSets from '@/views/CycleSets.vue';
import Products from '@/views/Products.vue';
import EngagementRewards from '@/views/EngagementRewards.vue';
import '@/plugins/axios';

import App from '@/App.vue';
import store from '@/store';
import router from './router';
import vuetify from './plugins/vuetify';

Vue.use(VueRouter);

// use following if you want /:clientId lockdown
// router.beforeEach(fiLockDown(store));
// router.beforeEach(appModeCheck(store));

// use following if you do NOT want /:clientId lockdown
store.dispatch('auth/initializePortalSession', store);

Vue.config.productionTip = false;

// handle page reloads
const app: Vue = new Vue({
  el: '#app',
  vuetify,
  store,
  router,
  components: {
    TransactionClassification,
    AccountStatusSettings,
    LegacyRedirect,
    IncomingRedirect,
    CoreManagement,
    RelationshipClassification,
    AccountTypes,
    StatementCodes,
    ProcessingDaysAndHolidays,
    InterestSettings,
    ATMSettings,
    AuditMessages,
    EocEmailSettings,
    CycleSets,
    Products,
    EngagementRewards,
  },
  render: h => h(App),
});
